export const CLEAR = "clear";

export const SET_LOCALE = "setLocale";

export const SET_API_CONFIG = "setApiConfig";

export const SET_TOKEN = "setToken";

export const SET_NETWORK_STATE = "setNetworkState";

export const SET_AUTH_INFO = "setAuthInfo";

export const SET_FOOD_CLASSIFY = "setFoodClassify";

export const SET_FOOD_INFO = "setFoodInfo";

export const SET_SEQ = 'setSeq'
